import { format } from 'owa-string-utils';
import { getLocalizedString } from 'owa-timeformat/lib/localization/getLocalizedString';

import { formatDateString } from '../formatTimeSpan';

import { OwaDate, owaDate } from 'owa-datetime';
import EndDateRecurrence from 'owa-service/lib/contract/EndDateRecurrence';
import NumberedRecurrence from 'owa-service/lib/contract/NumberedRecurrence';
import RecurrenceRangeBaseType from 'owa-service/lib/contract/RecurrenceRangeBaseType';

export default function formatEffectiveRange(
    timeZoneId: string,
    range: RecurrenceRangeBaseType,
    handleNumberedRecurrence: (start: OwaDate, numberOfOccurrences: number) => OwaDate,
    isShortString: boolean
): string {
    const startDate = owaDate(timeZoneId, range.StartDate);
    const formattedStartDate = formatDateString(startDate, isShortString);

    const endDateString = (<EndDateRecurrence>range).EndDate;
    const numberOfOccurrences = (<NumberedRecurrence>range).NumberOfOccurrences;
    const endDate = endDateString
        ? owaDate(timeZoneId, endDateString)
        : numberOfOccurrences
        ? handleNumberedRecurrence(startDate, numberOfOccurrences)
        : null;

    if (endDate) {
        const formattedEndDate = formatDateString(endDate, isShortString);
        return format(
            getLocalizedString('calendarEffectiveWithEndFormatString'),
            formattedStartDate,
            formattedEndDate
        );
    } else {
        return format(
            getLocalizedString('calendarEffectiveWithoutEndFormatString'),
            formattedStartDate
        );
    }
}
